<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card class="d-flex flex-column fill-height" style="position: relative;">
      <v-toolbar
        color="secondaryBackground"
        class="tiptap-editor-bar"
        :height="appBarHeight"
      >
        <v-btn
          class="editor-header__back-button"
          @click="$router.back()"
        >
        <v-icon class="mr-2">$chevronLeft</v-icon>
          <span class="regular-action-heading">{{ $t("storyHub.backToStoryHub") }}</span>
        </v-btn>
      </v-toolbar>
      <TipTapEditor class="description-tiptap-editor" />
    </v-card>
  </v-dialog>
</template>

<script>
  import TipTapEditor from '@/components/TipTapEditor';
  import { DEFAULT_APP_BAR_HEIGHT } from '@/const';

  export default {
    name: 'EditDescriptionDialog',
    components:{
      TipTapEditor
    },
    props: {
      value: Boolean,
    },
    data () {
      return {
        notifications: false,
        sound: true,
        widgets: false,
        dialog: this.value,
      }
    },
    computed: {
      appBarHeight() {
        return DEFAULT_APP_BAR_HEIGHT;
      },
    },
    watch: {
      dialog(newValue) {
        this.$emit('input', newValue)
      },
      value(newValue) {
        this.dialog = newValue
      }
    },
  }
</script>